import { render, staticRenderFns } from "./fixed-bar-society.vue?vue&type=template&id=3919c988&scoped=true&lang=pug&"
import script from "./fixed-bar-society.vue?vue&type=script&lang=js&"
export * from "./fixed-bar-society.vue?vue&type=script&lang=js&"
import style0 from "./fixed-bar-society.vue?vue&type=style&index=0&id=3919c988&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919c988",
  null
  
)

export default component.exports